export const sntoidData = [
  { id: 1, sn: 1 },
  { id: 2, sn: 2 },
  { id: 3, sn: 12 },
  { id: 4, sn: 11 },
  { id: 5, sn: 10 },
  { id: 6, sn: 9 },
  { id: 7, sn: 8 },
  { id: 8, sn: 7 },
  { id: 9, sn: 6 },
  { id: 10, sn: 5 },
  { id: 11, sn: 4 },
  { id: 12, sn: 3 },
  { id: 13, sn: 13 },
  { id: 14, sn: 16 },
  { id: 15, sn: 15 },
  { id: 16, sn: 14 },
  { id: 17, sn: 18 },
  { id: 18, sn: 34 },
  { id: 19, sn: 40 },
  { id: 20, sn: 39 },
  { id: 21, sn: 38 },
  { id: 22, sn: 37 },
  { id: 23, sn: 36 },
  { id: 24, sn: 35 },
  { id: 25, sn: 44 },
  { id: 26, sn: 43 },
  { id: 27, sn: 42 },
  { id: 28, sn: 41 },
  { id: 29, sn: 45 },
  { id: 30, sn: 46 },
  { id: 31, sn: 47 },
  { id: 32, sn: 48 },
  { id: 33, sn: 67 },
  { id: 34, sn: 68 },
  { id: 35, sn: 69 },
  { id: 36, sn: 70 },
  { id: 37, sn: 71 },
  { id: 38, sn: 72 },
  { id: 39, sn: 73 },
  { id: 40, sn: 74 },
  { id: 41, sn: 75 },
  { id: 42, sn: 76 },
  { id: 43, sn: 77 },
  { id: 44, sn: 78 },
  { id: 45, sn: 79 },
  { id: 46, sn: 80 },
  { id: 47, sn: 81 },
  { id: 48, sn: 82 },
  { id: 49, sn: 50 },
  { id: 50, sn: 51 },
  { id: 51, sn: 52 },
  { id: 52, sn: 53 },
  { id: 53, sn: 54 },
  { id: 54, sn: 55 },
  { id: 55, sn: 56 },
  { id: 56, sn: 57 },
  { id: 57, sn: 58 },
  { id: 58, sn: 59 },
  { id: 59, sn: 60 },
  { id: 60, sn: 61 },
  { id: 61, sn: 62 },
  { id: 62, sn: 63 },
  { id: 63, sn: 64 },
  { id: 64, sn: 65 },
];
export const classData = [
  { id: 1, name: "語文智能", question: [8, 12, 25, 27, 47, 48, 54, 56] },
  { id: 2, name: "邏輯數學智能", question: [9, 15, 29, 30, 33, 34, 59, 60] },
  { id: 3, name: "視覺空間智能", question: [2, 7, 17, 24, 41, 44, 49, 52] },
  { id: 4, name: "肢體動覺智能", question: [6, 10, 20, 23, 39, 45, 51, 55] },
  { id: 5, name: "音樂智能", question: [4, 5, 18, 21, 42, 43, 50, 53] },
  { id: 6, name: "內省智能", question: [14, 16, 28, 31, 35, 36, 61, 62] },
  { id: 7, name: "人際智能", question: [11, 13, 26, 32, 37, 38, 57, 58] },
  { id: 8, name: "自然智能", question: [1, 3, 19, 22, 40, 46, 63, 64] },
];
